export default {"src":"/_next/static/media/share.9d3c1181.svg","height":32,"width":32};